export interface PlatformPublicShop {
  name: string
  slug: string
  logo: string | null
  url: string
  hostLabel: string
  tagline: string | null
}

export function usePlatformShops() {
  const config = useRuntimeConfig()
  const shops = useState<PlatformPublicShop[]>('platform-public-shops', () => [])
  const loading = useState('platform-public-shops-loading', () => false)
  const loaded = useState('platform-public-shops-loaded', () => false)

  async function fetchShops() {
    if (loaded.value) return shops.value
    loading.value = true
    try {
      const res = await $fetch<{ success?: boolean, data?: PlatformPublicShop[] }>(
        `${String(config.public.platformApiUrl).replace(/\/$/, '')}/public/shops`,
      )
      shops.value = Array.isArray(res.data) ? res.data : []
      loaded.value = true
    } catch {
      shops.value = []
    } finally {
      loading.value = false
    }
    return shops.value
  }

  return { shops, loading, fetchShops }
}
